<template>
  <div class="pregled-vsebine">
    <div class="stran-brez-izbirnika">
      <div class="vsebina-postavitev">
        <div class="odmik-vsebine aplikacije">
          <div>
            <p class="naslov">
              T-2 Aplikacije
            </p>
            <p style="padding-top: 25px" class="primarna-barva-pisave">
              Življenja brez aplikacij si ne znamo več predstavljati. Naročnikom ponujamo mobilne
              aplikacije Horizont, Porabo in tv2go <br v-if="prikazTabele === '1'"/>
              ter aplikacijo za ogled T-2 televizije na pametnih televizorjih T-2 TV.
            </p>
          </div>
          <div class="grid-container" style="padding-top: 40px">
            <div>
              <div class="levi-pomik-slika">
                <img src="/static/img/T2Aplikacije/Horizont_512.png" class="velikost-slike">
              </div>
              <div>
                <div class="pomik-besedila-t2-aplikacije">
                  <p class="primarna-barva-pisave">
                    <b class="postavitev-naslova-t2-aplikacije">
                      T-2 Horizont
                    </b>
                  </p>
                  <p class="postavitev-besedila-t2-aplikacije primarna-barva-pisave">
                    Aplikacija T-2 Horizont <b> omogoča varen prostor za shranjevanje </b> vaših fotografij, video
                    posnetkov, glasbenih vsebin ali drugih datotek. Upravljanje je pregledno in
                    enostavno, vsebine pa lahko spremljate na več napravah, tudi na TV vmesnikih.
                    <br/>
                    <br/>
<!--                    <a :href="horizontTrgovinaPlayPovezava" class="primarna-barva ikona-vsebina" target="_blank">-->
<!--                      <img src="/static/img/T2Aplikacije/Icon-awesome-android.png"-->
<!--                           class="odmik-ikone">-->
<!--                      <span class="odmik-ikona-tekst">-->
<!--                        Trgovina Play-->
<!--                      </span>-->
<!--                    </a>-->
                    <a :href="horizontItunesPovezava" class="primarna-barva ikona-vsebina"
                       target="_blank">
                      <img src="/static/img/T2Aplikacije/Icon-awesome-apple.png"
                           class="odmik-ikone">
                      <span class="odmik-ikona-tekst">
                        App Store
                      </span>
                    </a>
                    <el-tooltip class="item primarna-barva" placement="bottom">
                      <div slot="content">
                        Aplikacijo lahko namestite iz trgovine Huawei AppGallery na <br/>
                        mobilnih napravah Huawei.
                      </div>
                      <a class="primarna-barva ikona-vsebina levi-odmik">
                        <img src="/static/img/T2Aplikacije/Icon-simple-huawei.png"
                             class="odmik-ikone">
                        <span class="odmik-ikona-tekst">
                          Huawei AppGallery
                        </span>
                      </a>
                    </el-tooltip>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div class="levi-pomik-slika">
                <img src="/static/img/T2Aplikacije/Poraba_512.png" class="velikost-slike">
              </div>
              <div>
                <div class="pomik-besedila-t2-aplikacije">
                  <p class="primarna-barva-pisave">
                    <b class="postavitev-naslova-t2-aplikacije">
                      T-2 Poraba
                    </b>
                  </p>
                  <p class="postavitev-besedila-t2-aplikacije primarna-barva-pisave">
                    Aplikacija <b> omogoča spremljanje uporabe storitev T-2 </b> in porabe enot za
                    mobilne in stacionarne telefonske številke, podatke o poslanih SMS in MMS
                    sporočilih ter podatke o mobilnem internetnem podatkovnem prometu za obdobje
                    zadnjih treh mesecev.
                    <br/>
                    <br/>
                    <a :href="t2PorabaTrgovinaPlayPovezava" class="primarna-barva ikona-vsebina"
                       target="_blank">
                      <img src="/static/img/T2Aplikacije/Icon-awesome-android.png"
                           class="odmik-ikone">
                      <span class="odmik-ikona-tekst">
                        Trgovina Play
                      </span>
                    </a>
                    <a :href="t2PorabaItunesPovezava" class="primarna-barva ikona-vsebina levi-odmik"
                       target="_blank">
                      <img src="/static/img/T2Aplikacije/Icon-awesome-apple.png"
                           class="odmik-ikone">
                      <span class="odmik-ikona-tekst">
                        App Store
                      </span>
                    </a>
                    <el-tooltip class="item primarna-barva" placement="bottom">
                      <div slot="content">
                        Aplikacijo lahko namestite iz trgovine Huawei AppGallery na <br/>
                        mobilnih napravah Huawei.
                      </div>
                      <a class="primarna-barva ikona-vsebina levi-odmik">
                        <img src="/static/img/T2Aplikacije/Icon-simple-huawei.png"
                             class="odmik-ikone">
                        <span class="odmik-ikona-tekst">
                          Huawei AppGallery
                        </span>
                      </a>
                    </el-tooltip>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div class="levi-pomik-slika">
                <img src="/static/img/T2Aplikacije/T2TV_512.png" class="velikost-slike">
              </div>
              <div>
                <div class="pomik-besedila-t2-aplikacije">
                  <p class="primarna-barva-pisave">
                    <b class="postavitev-naslova-t2-aplikacije">
                      Tv2go
                    </b>
                  </p>
                  <p class="postavitev-besedila-t2-aplikacije primarna-barva-pisave">
                    T-2 tv2go je <b> aplikacija za spremljanje T-2 televizije na mobilnih napravah,
                  </b> brskanje po sporedih, nastavljanje opomnikov in uporabo drugih
                    multimedijskih funkcij. Omogoča spremljanje več kot 100 TV programov, tudi
                    v visoki ločljivosti. Na aplikaciji lahko uporabljate tudi časovni zamik za
                    sedem dni nazaj.
                    <br/>
                    <br/>
                    <a :href="t2ToGoTrgovinaPlayPovezava" class="primarna-barva ikona-vsebina" target="_blank">
                      <img src="/static/img/T2Aplikacije/Icon-awesome-android.png"
                           class="odmik-ikone">
                      <span class="odmik-ikona-tekst">
                        Trgovina Play
                      </span>
                    </a>
                    <a :href="t2TpGoItunesPovezava" class="primarna-barva ikona-vsebina levi-odmik"
                       target="_blank">
                      <img src="/static/img/T2Aplikacije/Icon-awesome-apple.png"
                           class="odmik-ikone">
                      <span class="odmik-ikona-tekst">
                        App Store
                      </span>
                    </a>
                    <el-tooltip class="item primarna-barva levi-odmik" placement="bottom">
                      <div slot="content">
                        Aplikacijo lahko namestite iz trgovine Huawei AppGallery na <br/>
                        mobilnih napravah Huawei.
                      </div>
                      <a class="primarna-barva ikona-vsebina levi-odmik">
                        <img src="/static/img/T2Aplikacije/Icon-simple-huawei.png"
                             class="odmik-ikone">
                        <span class="odmik-ikona-tekst">
                          Huawei AppGallery
                        </span>
                      </a>
                    </el-tooltip>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div class="levi-pomik-slika">
                <img src="/static/img/T2Aplikacije/tv2go_512.png" class="velikost-slike">
              </div>
              <div>
                <div class="pomik-besedila-t2-aplikacije">
                  <p class="primarna-barva-pisave">
                    <b class="postavitev-naslova-t2-aplikacije">
                      T-2 TV
                    </b>
                  </p>
                  <p class="postavitev-besedila-t2-aplikacije primarna-barva-pisave">
                    Spoznajte aplikacijo T-2 TV, s katero lahko <b> programe gledate kar preko
                    aplikacije na vašem pametnem televizorju. </b> Uporabniška izkušnja je povsem
                    enaka kot na TV vmesniku in omogoča vse funkcionalnosti T-2 televizije: časovni
                    zamik, izposojo vsebin v videotekah, uporabo snemalnika, opomnikov in ostalo.
                    <br/>
                    <br/>
                    <a :href="povezavaAndroidTv" class="primarna-barva ikona-vsebina" target="_blank">
                      <img src="/static/img/T2Aplikacije/Icon-awesome-android.png"
                           class="odmik-ikone">
                      <span class="odmik-ikona-tekst">
                        Trgovina Play
                      </span>
                    </a>
                    <el-tooltip class="item" placement="bottom">
                      <div slot="content">
                        Aplikacijo lahko namestite iz trgovine z aplikacijami Apps <br/>
                        na pametnih televizorjih Samsung.
                      </div>
                      <a class="primarna-barva ikona-vsebina levi-odmik"
                         target="_blank">
                        <img src="/static/img/T2Aplikacije/g6894.png"
                             class="odmik-ikone">
                        <span class="odmik-ikona-tekst">
                          Tizen
                        </span>
                      </a>
                    </el-tooltip>
                    <a :href="fireTv" class="primarna-barva ikona-vsebina levi-odmik" target="_blank">
                      <img src="/static/img/T2Aplikacije/iconfinder_amazon_1608498.png" class="odmik-ikone">
                      <span class="odmik-ikona-tekst">
                        Amazon Fire TV
                      </span>
                    </a>
                    <a :href="tvAplikacija" class="primarna-barva ikona-vsebina vec"
                       target="_blank">
                      <i class="fa fa-info-circle ikona-circle-stil">
                      </i>
                      <span class="odmik-ikona-tekst odmik-t2-tv">
                          Več o T-2 TV aplikaciji
                        </span>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Tooltip} from 'element-ui'
import {povezave} from './../../../../assets/js/Povezave/povezave'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {SirinaOkna} from '../../../../assets/js/globalne_funkcije/SirinaOkna'

export default {
  name: 'T2Aplikacije',
  mixins: [SirinaOkna],
  data () {
    return {
      povezavaAndroidTv: '',
      t2TpGoItunesPovezava: '',
      t2ToGoTrgovinaPlayPovezava: '',
      t2PorabaItunesPovezava: '',
      t2PorabaTrgovinaPlayPovezava: '',
      horizontItunesPovezava: '',
      horizontTrgovinaPlayPovezava: '',
      tvAplikacija: '',
      fireTv: '',
      mejnaSirinaTabela: 1400,
      prikazTabele: '1'
    }
  },
  components: {
    [Tooltip.name]: Tooltip
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
    })
    this.povezavaAndroidTv = povezave.BASE_URL_ANDROID_TV_POVEZAVA
    this.t2TpGoItunesPovezava = povezave.BASE_URL_T2TGO_IOS_POVEZAVA
    this.t2ToGoTrgovinaPlayPovezava = povezave.BASE_URL_T2TGO_ANDROID_POVEZAVA
    this.t2PorabaItunesPovezava = povezave.BASE_URL_PORABA_IOS_POVEZAVA
    this.t2PorabaTrgovinaPlayPovezava = povezave.BASE_URL_PORABA_ANDROID_POVEZAVA
    this.horizontItunesPovezava = povezave.BASE_URL_HORIZONT_IOS_POVEZAVA
    this.horizontTrgovinaPlayPovezava = povezave.BASE_URL_HORIZONT_ANDROID_POVEZAVA
    this.tvAplikacija = povezave.BASE_URL_TV_APLIKACIJA
    this.fireTv = povezave.BASE_URL_FIRE_TV
  }
}
</script>
<style scoped src="../../../../../static/css/UporabniskiKoticek/T2Aplikacije.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/T2Aplikacije.vue